__turbopack_context__.v({
  "bottomShadow": "_6eYazW_bottomShadow",
  "btn": "_6eYazW_btn",
  "cell": "_6eYazW_cell",
  "expanded": "_6eYazW_expanded",
  "grid": "_6eYazW_grid",
  "gridContainer": "_6eYazW_gridContainer",
  "header": "_6eYazW_header",
  "logo": "_6eYazW_logo",
  "root": "_6eYazW_root",
  "subheader": "_6eYazW_subheader",
});
